// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__2Q_4v","heading":"style_heading__1bbBe","subHeading":"style_subHeading__3k2Go"};